<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>admin</ion-title>
  </ion-toolbar>
</ion-header> -->

<ion-header [translucent]="true">
  <ion-toolbar>
      <ion-title>My History</ion-title>
      <ion-buttons slot="end">
        <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
        <!-- <ion-title style="cursor: pointer;" size="large" (click)="goToAdminPage()">Admin</sion-title> -->
        <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">history</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid>
    <ion-row>
      <ion-col size="3">
       
      </ion-col>
      
     

      <ion-col size="3" class="search-container">
        <ion-searchbar 
          [(ngModel)]="searchQuery" 
          (ionInput)="onSearchInput($event)" 
          (keydown)="onEnterKey($event)"
          placeholder="Search...">
        </ion-searchbar>
        <ion-button (click)="onSearchClick()" [disabled]="!searchQuery || searchQuery.trim() === ''">Search</ion-button>
      </ion-col>

    
       <ion-col size="2" class="search-container">
        <div class="date-picker-container">
          <!-- <label for="startDate" class="date-label">Start Date</label> -->
          <input 
            type="date" 
            id="startDate" 
            [(ngModel)]="startDate" 
            (change)="onDateChange('startDate', $event)" 
            [value]="formatSelectedDate(startDate)" 
            class="date-input">
        </div>
      
        <div class="date-picker-container">
          <!-- <label for="endDate" class="date-label">End Date</label> -->
          <input 
            type="date" 
            id="endDate" 
            [(ngModel)]="endDate" 
            (change)="onDateChange('endDate', $event)" 
            [value]="formatSelectedDate(endDate)" 
            class="date-input">
        </div>
        <!-- <ion-button (click)="onSearchClick()" [disabled]="!searchQuery || searchQuery.trim() === ''">Search</ion-button> -->
        <ion-button style="padding: 5px;" (click)="applyFilter()" [disabled]="!startDate || !endDate">{{ isFilterApplied ? 'Clear' : 'Filter' }}</ion-button>
      
      </ion-col>
      

     
      

      <!-- <ion-col size="2" class="ion-align-self-center">
        <ion-button expand="full" (click)="applyFilter()">Filter</ion-button>
      </ion-col> -->

    </ion-row>

    <ion-row *ngIf="errorMessage" class="error-message" full-height>
      {{ errorMessage }}
    </ion-row>


    <ion-row>
      

      <!-- Table Headers -->
      <ion-col size="2"><strong>Client Name</strong></ion-col>
      <ion-col size="3"><strong>Audio</strong></ion-col>
      <ion-col size="2"><strong>Usable</strong></ion-col>
      <ion-col size="2"><strong>IsForInterpretationOnly</strong></ion-col>
      <ion-col size="2"><strong>Date</strong></ion-col>
      <ion-col size="1"><strong>Actions</strong></ion-col>
    </ion-row>

    <!-- Table Data Rows -->
    <ion-row *ngFor="let item of data">
      <ion-col size="2">{{ item.Client_name }}</ion-col>
      <!-- <ion-col size="2">{{ item.Text }}</ion-col> -->
      
     
      <ion-col size="3">
        <div>
          <p>{{ item.Text }}</p>
          <audio controls *ngIf="item.Audiopath" preload="none">
            <source [src]="item.Audiopath" type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>

        </div>
      </ion-col>
      <ion-col size="2">
        <ion-toggle [(ngModel)]="item.Usable" (ionChange)="onUsableChange($event, item)"></ion-toggle>
        <!-- <ion-toggle [(ngModel)]="item.Usable"></ion-toggle> -->
      </ion-col>
      <ion-col size="2">
        <ion-toggle [(ngModel)]="item.IsForInterpretation" (ionChange)="onIsForInterpretationOnlyChange($event, item)"></ion-toggle>
      </ion-col>
      <ion-col size="2">{{formatDate(item.Datecreted)}}</ion-col>
      <ion-col size="1">
        <div class="tooltip-wrapper">
          <ion-button class="zoom-icon-button" style="width: auto !important;" fill="clear" color="primary" (click)="deleteAudioFile(item)">
            <ion-icon slot="icon-only" name="trash-outline" ></ion-icon>
          </ion-button>
          <span class="custom-tooltip">Delete Audio</span>
        </div>
      </ion-col>
    </ion-row>
    
    <!-- <ion-row>
      Data Creation Tool
    </ion-row>
    <ion-row>
      Data Creation Tool
    </ion-row> -->
    <!-- <ion-row class="spaced-row">
    </ion-row>
    <ion-row class="spaced-row">
    </ion-row> -->
    <div style="margin-bottom: 80px;"></div>
    
  </ion-grid>




<ion-footer class="pagination-footer">
  <ion-toolbar>
    <ion-row justify-content-center align-items-center class="pagination-row">
      <!-- First Page Button -->
      <ion-col size="auto" class="text-center">
        <ion-button fill="solid" color="primary" (click)="goToPage(1)" [disabled]="currentPage <= 1">First</ion-button>
      </ion-col>

      <!-- Previous Page Button -->
      <ion-col size="auto" class="text-center">
        <ion-button fill="solid" color="primary" (click)="goToPage(currentPage - 1)" [disabled]="currentPage <= 1">
          Previous
        </ion-button>
      </ion-col>

      <ion-col size="auto" class="text-center">
        <ion-item lines="none" class="input-container">
          <div>
            <!-- <ion-label>
              {{ goToPageNumber }} / {{ totalPages }}
            </ion-label> -->
            <!-- <ion-input type="number" [(ngModel)]="goToPageNumber" placeholder="Page #" min="1" [max]="totalPages"> -->

            <!-- </ion-input> -->
              <span class="page-info">{{ goToPageNumber || 1 }} / {{ totalPages }}</span>

            <!-- <p class="page-info">
               {{ goToPageNumber || 1 }} / {{ totalPages }}
            </p> -->
          </div>
        </ion-item>
        <!-- <ion-button fill="solid" color="primary" (click)="goToSpecificPage()" [disabled]="!goToPageNumber || goToPageNumber < 1 || goToPageNumber > totalPages">
          Go
        </ion-button> -->
      </ion-col>

      <!-- Page Number Buttons -->
      <!-- <ion-col size="auto" class="text-center">
        <ion-buttons>
          <ion-button *ngFor="let page of getPages()" (click)="goToPage(page)">
            {{ page }}
          </ion-button>
        </ion-buttons>
      </ion-col> -->

      <!-- Next Page Button -->
      <ion-col size="auto" class="text-center">
        <ion-button fill="solid" color="primary" (click)="goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages">
          Next
        </ion-button>
      </ion-col>

      <!-- Last Page Button -->
      <ion-col size="auto" class="text-center">
        <ion-button fill="solid" color="primary" (click)="goToPage(totalPages)" [disabled]="currentPage >= totalPages">
          Last
        </ion-button>
      </ion-col>

      <!-- Go to Page Input -->
      <ion-col size="auto" class="text-center">
        <ion-item lines="none" class="input-container">
          <ion-input type="number" [(ngModel)]="goToPageNumber" (keydown)="onKeyPress($event)" placeholder="Page #" min="1" [max]="totalPages"></ion-input>
        </ion-item>
        
      </ion-col>
      <ion-col size="auto" class="text-center">
        <ion-button fill="solid" color="primary" (click)="goToSpecificPage()" [disabled]="!goToPageNumber || goToPageNumber < 1 || goToPageNumber > totalPages || totalPages ===1">
          Go
        </ion-button>

      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>



</ion-content>
